export const right = {
	ADMIN: 'ADMIN'
};

export const user = {
	VIEW: "VIEW",
	EDIT: "EDIT"
};

export const party = {
	VIEW: "VIEW",
	EDIT: "EDIT"
};

export const isAllowed = (session, r) => {
	if (!session || !session.user.userId || !session.rights) {
		return false
	}

	return session.rights.indexOf(r) > -1
		|| session.rights.indexOf(right.ADMIN) > -1
};

export const isLoggedIn = (session) => {
	if (!session || !session.user.userId) {
		return false
	}
	return true
};

export const changedLoggedIn = (prevProps, nextProps) => {
	if (!isLoggedIn(prevProps.session) && isLoggedIn(nextProps.session)) {
		return true
	} else {
		return false
	}
};

export const hasAction = (item, action) => {
	if (!item || !item.allowedActions) {
		return false
	}

	return item.allowedActions.indexOf(action) > -1
};



// WEBPACK FOOTER //
// ./src/utils/acl.js